"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getManager = exports.getDirectReports = exports.getStaffByFilterCriteria = exports.getAllStaffMembers = exports.initialize = void 0;
var axios_1 = __importDefault(require("axios"));
var axiosUtils_1 = require("../utils/axiosUtils");
var Environment_1 = require("../models/enums/Environment");
var StatusFilter_1 = require("../models/enums/StatusFilter");
var numberOfTimesToRetry = 5;
var staffApiBasePath;
var arculusApiKey;
var headerOptions;
var getBasePath = function (config) {
    return config && config.environment && config.environment === Environment_1.Environment.Test
        ? "https://proxy.test.arc.fdot.gov/Staff/v3"
        : "https://proxy.arc.fdot.gov/staff/v3";
};
var initialize = function (config) {
    if (!config.arculusApiKey) {
        throw new Error("The arculusApiKey must be provided in the configuration object.");
    }
    if (config.environment !== Environment_1.Environment.Test &&
        config.environment !== Environment_1.Environment.Production) {
        throw new Error("The environment must be provided and must be either: ".concat(Environment_1.Environment.Test, " or ").concat(Environment_1.Environment.Production, "."));
    }
    staffApiBasePath = getBasePath(config);
    arculusApiKey = config.arculusApiKey;
    headerOptions = {
        headers: { "Ocp-Apim-Subscription-Key": arculusApiKey },
        withCredentials: false,
    };
};
exports.initialize = initialize;
var getAllStaffMembers = function (statusFilter) {
    if (statusFilter === void 0) { statusFilter = StatusFilter_1.StatusFilter.ActiveOnly; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, axiosUtils_1.getWithRetry)(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var statusParameter;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    statusParameter = statusFilter === StatusFilter_1.StatusFilter.ActiveOnly
                                        ? "active"
                                        : statusFilter === StatusFilter_1.StatusFilter.InactiveOnly
                                            ? "inactive"
                                            : "all";
                                    return [4 /*yield*/, axios_1.default.get("".concat(staffApiBasePath, "/staff?status=").concat(statusParameter), headerOptions)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }, numberOfTimesToRetry)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
exports.getAllStaffMembers = getAllStaffMembers;
var getStaffByFilterCriteria = function (filterCriteria) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = buildFilterUrl(filterCriteria);
                return [4 /*yield*/, (0, axiosUtils_1.getWithRetry)(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, axios_1.default.get(url, headerOptions)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }, numberOfTimesToRetry)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getStaffByFilterCriteria = getStaffByFilterCriteria;
var getDirectReports = function (srsId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, axiosUtils_1.getWithRetry)(function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, axios_1.default.get("".concat(staffApiBasePath, "/staff/").concat(srsId, "/direct-reports"), headerOptions)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); }, numberOfTimesToRetry)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getDirectReports = getDirectReports;
var getManager = function (srsId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, axiosUtils_1.getWithRetry)(function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, axios_1.default.get("".concat(staffApiBasePath, "/staff/").concat(srsId, "/manager"), headerOptions)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); }, numberOfTimesToRetry)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getManager = getManager;
var buildFilterUrl = function (filterCriteria) {
    var url = "".concat(staffApiBasePath, "/staff?");
    url = addArrayParam(url, "azure-ad-oid", filterCriteria.azureAdOids);
    url = addStringParam(url, "district-code", filterCriteria.district);
    url = addStringParam(url, "email-address", filterCriteria.emailAddress);
    url = addStringParam(url, "first-name", filterCriteria.firstName);
    url = addStringParam(url, "last-name", filterCriteria.lastName);
    url = addStringParam(url, "org-code", filterCriteria.orgCode);
    url = addStringParam(url, "partial-name", filterCriteria.partialName);
    url = addStringParam(url, "search-term", filterCriteria.searchTerm);
    url = addStringParam(url, "people-first-id", filterCriteria.peopleFirstId);
    url = addArrayParam(url, "position-number", filterCriteria.positionNumbers);
    url = addArrayParam(url, "racf-id", filterCriteria.racfIds);
    url = addArrayParam(url, "staff-id", filterCriteria.staffIds);
    url = addArrayParam(url, "staff-type-code", filterCriteria.staffTypeCodes);
    url = addStringParam(url, "status", filterCriteria.status);
    // Trim last character off (e.g. ? or &)
    url = url.substring(0, url.length - 1);
    return url;
};
var addStringParam = function (url, parameterKey, parameterValue) {
    if (parameterValue !== undefined && parameterValue !== "") {
        url += createQueryStringParameter(parameterKey, parameterValue);
    }
    return url;
};
var addArrayParam = function (url, parameterKey, parameterValue) {
    if (parameterValue !== undefined && parameterValue.length > 0) {
        var arrayParams = parameterValue
            .map(function (i) { return createQueryStringParameter(parameterKey, i); })
            .join("");
        url += arrayParams;
    }
    return url;
};
var createQueryStringParameter = function (parameterKey, parameterValue) {
    return "".concat(parameterKey, "=").concat(encodeURIComponent(parameterValue), "&");
};
